import React from "react";
import OffWrap from '../../components/Layout/Header/OffWrap';
import Footer from '../../components/Layout/Footer/FooterStyleOne';
import SearchModal from '../../components/Layout/Header/SearchModal';
import ScrollToTop from '../../components/Common/ScrollTop';
import Newsletter from '../../components/Common/Newsletter';
import Header from '../../components/Layout/Header/Header';
import Logo from "../../assets/img/logo/dark-logo.png";
import footerLogo from "../../assets/img/logo/lite-logo.png";

const ProjectsPage = () => (
  <React.Fragment>
    <OffWrap />
    <Header
      parentMenu="about"
      secondParentMenu="projects"
      headerNormalLogo={Logo}
      headerStickyLogo={Logo}
      CanvasLogo={Logo}
      mobileNormalLogo={Logo}
      CanvasClass="right_menu_togle hidden-md"
      headerClass="full-width-header header-style1 home8-style4"
      TopBar="enable"
      TopBarClass="topbar-area home8-topbar"
      emailAddress="hello@syroltech.com"
      Location="Abuja, Nigeria"
    />
    <section style={{ minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#fafbfc' }}>
      <div style={{ textAlign: 'center' }}>
        <h1 style={{ fontSize: '2.5rem', fontWeight: 700, color: 'var(--brand-primary)', marginBottom: 16 }}>Projects</h1>
        <p style={{ fontSize: '1.3rem', color: '#222', marginBottom: 32 }}>This page is coming soon. Stay tuned for our latest case studies and success stories!</p>
      </div>
    </section>
    <Newsletter
      sectionClass="rs-newsletter style1 orange-color event-bg mb--90 sm-mb-0 sm-pb-80"
      titleClass="title mb-0 white-color"
    />
    <Footer
      footerClass="rs-footer home9-style main-home"
      footerLogo={footerLogo}
    />
    <SearchModal />
    <ScrollToTop scrollClassName="scrollup orange-color" />
  </React.Fragment>
);

export default ProjectsPage; 